var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28027 0.774298C3.58388 0.773266 3.88386 0.840273 4.15818 0.970396C4.43249 1.10052 4.67416 1.29045 4.86543 1.52623L14.6812 13.7198C14.9801 14.0834 15.1436 14.5395 15.1436 15.0103C15.1436 15.481 14.9801 15.9371 14.6812 16.3007L4.51995 28.4943C4.175 28.9093 3.67931 29.1703 3.14192 29.2199C2.60454 29.2694 2.06949 29.1034 1.65447 28.7585C1.23945 28.4135 0.978455 27.9178 0.928909 27.3805C0.879363 26.8431 1.04532 26.308 1.39027 25.893L10.4745 15.0001L1.69511 4.1072C1.4466 3.8089 1.28874 3.44565 1.24021 3.06044C1.19168 2.67522 1.25451 2.28417 1.42127 1.93355C1.58803 1.58293 1.85174 1.28741 2.18119 1.08197C2.51064 0.876532 2.89204 0.769762 3.28027 0.774298Z",
    fill: "#3F7DBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/RightArrowIcon.a6f44a2a4b233613b82c8fb117c7eebe.svg";
export { ForwardRef as ReactComponent };